import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';
import { DraftAccountDTO } from '../../../AccountOpening.meta';
import { SpaceProps } from '../../../../../theme/styledProps';
import { EditableField } from '../../../components/EditableField/EditableField';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { getIncomeOption, netWorthOpts } from '../NetWorthFields.meta';

interface Props extends SpaceProps {
  isReview?: boolean;
  draftAccount: DraftAccountDTO;
}

export const TotalNetWorth: React.FC<Props> = ({ isReview, draftAccount, ...rest }) => {
  const formBag = useFormContext();

  const { totalNetWorthUSDMin, totalNetWorthUSDDefault } = draftAccount;

  const [isEditing, setIsEditing] = useState(!isReview);

  const [incomeOpt, setIncomeOpt] = useState(() =>
    getIncomeOption(totalNetWorthUSDMin, totalNetWorthUSDDefault, netWorthOpts),
  );

  if (!isEditing) {
    return <EditableField onEdit={() => setIsEditing(true)}>{incomeOpt.label}</EditableField>;
  }

  return (
    <Box {...rest}>
      <input
        defaultValue={incomeOpt.value.min}
        type="hidden"
        {...formBag.register('totalNetWorthUSDMin', { valueAsNumber: true })}
      />
      <input
        defaultValue={incomeOpt.value.max}
        type="hidden"
        {...formBag.register('totalNetWorthUSDMax', { valueAsNumber: true })}
      />

      <Select
        value={incomeOpt}
        label={isReview ? undefined : 'Estimated Total Net Worth'}
        onChange={opt => {
          if (opt) {
            formBag.setValue('totalNetWorthUSDMin', opt.value.min);
            formBag.setValue('totalNetWorthUSDMax', opt.value.max);

            setIncomeOpt(opt);
          }
        }}
        options={netWorthOpts}
        aria-label="Estimated Total Net Worth"
      />
    </Box>
  );
};
